"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Contents = void 0;

var tslib_1 = require("tslib");

var ui_helper_hooks_1 = require("@hopin-team/ui-helper-hooks");

var focus_trap_react_1 = tslib_1.__importDefault(require("focus-trap-react"));

var react_1 = tslib_1.__importStar(require("react"));

var contents_1 = require("../styled/contents");

var control_button_1 = require("../styled/control-button");

var scroll_1 = require("../styled/scroll");

var Contents = function Contents(_a) {
  var _b = _a.background,
      background = _b === void 0 ? 'grey-white' : _b,
      children = _a.children,
      _c = _a.closeLabel,
      closeLabel = _c === void 0 ? 'Close modal' : _c,
      describedById = _a.describedById,
      labelledById = _a.labelledById,
      isDismissible = _a.isDismissible,
      shadow = _a.shadow,
      label = _a.label,
      onClose = _a.onClose;
  (0, ui_helper_hooks_1.useOnKeyPress)('Escape', onClose);
  var rootRef = (0, react_1.useRef)(null);
  (0, ui_helper_hooks_1.useOnClickOutside)(rootRef, onClose, {
    isActive: isDismissible
  });

  var _d = tslib_1.__read((0, react_1.useState)(null), 2),
      fallbackComponent = _d[0],
      setFallbackComponent = _d[1];

  (0, ui_helper_hooks_1.useBodyLock)(fallbackComponent, true); // NOTE: Using callback ref pattern here, because FocusTrap component can only
  // mount when the focus fallbackComponent is mounted and available. Using this
  // pattern allows tracking changes in the ref state (as opposed to useRef).

  var refCallback = (0, react_1.useCallback)(function (node) {
    if (node !== null) {
      setFallbackComponent(node);
    }
  }, []);
  var focusTrapOptions = {
    fallbackFocus: fallbackComponent !== null && fallbackComponent !== void 0 ? fallbackComponent : undefined,
    allowOutsideClick: Boolean(isDismissible)
  };
  return react_1.default.createElement(contents_1.ContentsRoot, {
    "aria-describedby": describedById,
    "aria-labelledby": labelledById,
    "aria-label": label,
    "aria-modal": true,
    ref: rootRef,
    role: "dialog",
    shadow: shadow
  }, react_1.default.createElement(contents_1.Container, {
    background: background
  }, react_1.default.createElement(scroll_1.Scroll, {
    ref: refCallback
  }, fallbackComponent && react_1.default.createElement(focus_trap_react_1.default, {
    focusTrapOptions: focusTrapOptions
  }, react_1.default.createElement("div", null, react_1.default.createElement(control_button_1.ControlButton, {
    icon: "close",
    onClick: onClose,
    title: closeLabel,
    isGhost: true
  }), react_1.default.createElement("div", {
    tabIndex: -1
  }, children))))));
};

exports.Contents = Contents;
Contents.displayName = 'SidePanelModalContents';